import { render, staticRenderFns } from "./CourseSections.vue?vue&type=template&id=00a7bf0c&"
import script from "./CourseSections.vue?vue&type=script&lang=ts&"
export * from "./CourseSections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports